import type { FormField } from '@cli-types/core-engine/schema.js'
import { formColumnTypeForField } from '../schema-prompts/form-column-type-for-field.js'

export function getUserAddedSubmissionColumnFields(
  fields: FormField[]
): Array<FormField & { name: string }> {
  return fields.filter((field): field is FormField & { name: string } => {
    return Boolean(field.name && field.name !== 'title' && formColumnTypeForField(field))
  })
}
